import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "" }

import { OvertimeModel } from "@/services/entities/OvertimeModel";
import TileCard from "./util/TileCard.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'OvertimeOverview',
  props: {
  overtimeModel: { Type: {} as OvertimeModel, default: {} as OvertimeModel },
  loaded: { Type: {} as boolean, default: {} as boolean }
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TileCard, {
    id: "overtime",
    loaded: !props.loaded
  }, {
    body: _withCtx(() => [
      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "title-2" }, "Overtimes overview in hours", -1)),
      _createElementVNode("table", null, [
        _cache[8] || (_cache[8] = _createElementVNode("thead", null, null, -1)),
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _cache[0] || (_cache[0] = _createElementVNode("td", { class: "name" }, "Total project overtime", -1)),
            _createElementVNode("td", _hoisted_1, [
              _createElementVNode("span", null, [
                _createElementVNode("b", null, _toDisplayString(props.overtimeModel.projectTotal), 1)
              ])
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("td", null, "hours", -1))
          ]),
          _createElementVNode("tr", null, [
            _cache[2] || (_cache[2] = _createElementVNode("td", { class: "name" }, "Floating overtime this month", -1)),
            _createElementVNode("td", _hoisted_2, [
              _createElementVNode("span", null, [
                _createElementVNode("b", null, _toDisplayString(props.overtimeModel.floatingThisMonth), 1)
              ])
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("td", null, "hours", -1))
          ]),
          _createElementVNode("tr", null, [
            _cache[4] || (_cache[4] = _createElementVNode("td", { class: "name" }, "Project overtime this month", -1)),
            _createElementVNode("td", _hoisted_3, [
              _createElementVNode("span", null, [
                _createElementVNode("b", null, _toDisplayString(props.overtimeModel.projectThisMonth), 1)
              ])
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("td", null, "hours", -1))
          ]),
          _createElementVNode("tr", null, [
            _cache[6] || (_cache[6] = _createElementVNode("td", { class: "name" }, "Project overtime compensation this month", -1)),
            _createElementVNode("td", _hoisted_4, [
              _createElementVNode("span", null, [
                _createElementVNode("b", null, _toDisplayString(props.overtimeModel.otCompensationHours), 1)
              ])
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("td", null, "hours", -1))
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["loaded"]))
}
}

})